<template>
  <div class="invite-control text-big">
    <div class="row">
      <p class="col-sm-8 col-sm-offset-1">Invite with link</p>
    </div>
    <div class="row">
      <div class="col-sm-8 col-sm-offset-1">
        <div class="invite-link-wrapper form-control form-control-lg">
          <input
            id="inviteLink"
            ref="inviteLink"
            type="text"
            class="invite-link-input"
            @click="selectCodeUrl()"
            :placeholder="model.inviteUrl"
            :value="model.inviteUrl"
            aria-label="Invite link"
          />
        </div>
      </div>
      <div class="col-sm-2 col-xs-12 text-center copy-link-button">
        <a
          role="button"
          href="javascript:void(0)"
          @click="copyToClipboard(emitInviteAction)"
          class="btn btn-lg invite-button"
          :class="{ 'btn-default-copy': !copied, 'btn-default-tick': copied }"
          data-test="copy-invite-link"
        >
          {{ copied ? "Copied!" : "Copy link" }}
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-sm-offset-1">
        <p><small>Copy this link and send it via your own email or messaging.</small></p>
      </div>
    </div>
    <div class="row" style="margin-top: 1rem">
      <p class="col-sm-8 col-sm-offset-1">Invite with email</p>
    </div>
    <div class="row">
      <TeamInviteSender
        :user-tags="model.userTags"
        :sendUrl="model.sendUrl"
        :deleteUrl="model.deleteUrl"
        @send-started="onSendEvent(emitInviteAction)"
        @delete-started="onDeletedEvent"
        @delete-completed="onDeletedEvent"
        @previous-invites="onPreviousInvites"
      />
    </div>
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <p><small>Enter your colleagues' email addresses to send them an invitation.</small></p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { InviteControlApiModel } from "../../api-models";
import useInviteControlBase from "./useInviteControlBase";
import TeamInviteSender from "./team-invite-sender.vue";

const props = withDefaults(
  defineProps<{
    model: InviteControlApiModel;
    showExamples?: boolean;
  }>(),
  {
    showExamples: false,
  },
);

const emit = defineEmits(["invite-action", "previous-invites", "deleted-event"]);

const { copied, copyToClipboard, onSendEvent, selectCodeUrl } = useInviteControlBase(props.model);

function emitInviteAction() {
  emit("invite-action");
}

function onPreviousInvites(): void {
  emit("previous-invites");
}

function onDeletedEvent(): void {
  emit("deleted-event");
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";
h3 {
  margin-top: 50px;
}
.invite-button {
  @media (max-width: @screen-xs-max) {
    margin-top: 10px;
  }
}

.invite-control-tab-transition-enter,
.invite-control-tab-transition-leave-to {
  opacity: 0;
}

.invite-control-fadeable {
  transition: opacity 0.5s;
}

.invite-link-wrapper {
  height: 48px;
  line-height: 32px;
  width: 100% !important;
  background-color: rgba(239, 239, 239, 0.3);
}

.invite-link-wrapper input {
  border-width: 0 !important;
  font-size: 18px;
  outline: none !important;
  width: 100%;
  min-width: 100%;
  background-color: transparent;
  padding: 6px 12px;
  margin: -6px -12px;
}

.invite-code-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  margin-bottom: 5px;

  input {
    flex-grow: 1;
    margin-right: 5px;
  }

  > * {
    margin-right: 5px;
  }

  :last-child {
    margin: 0;
  }

  .btn-default .glyphicon {
    position: relative;
    top: 2px;
  }
}

.copy-link-button {
  padding-left: 0;

  @media (max-width: @screen-sm-max) {
    padding-left: 15px;
  }
}
</style>
